import type { DataTableProps } from './data-table.interface'

interface NormalizedDataTableProps<TData> {
  data: TData[]
  columnList: DataTableProps<TData>['columnList']
  getRowId: (row: TData) => string
  isSelectable: boolean
  selectedIdList: string[]
  onSelectionChange?: DataTableProps<TData>['onSelectionChange']
  actionList: NonNullable<DataTableProps<TData>['actionList']>
  pagination?: DataTableProps<TData>['pagination']
  onPageChange?: DataTableProps<TData>['onPageChange']
  onPageSizeChange?: DataTableProps<TData>['onPageSizeChange']
  searchValue?: string
  onSearchChange?: DataTableProps<TData>['onSearchChange']
  searchPlaceholder?: string
  sortBy?: string
  sortOrder?: DataTableProps<TData>['sortOrder']
  onSortChange?: DataTableProps<TData>['onSortChange']
  filterList?: DataTableProps<TData>['filterList']
  filterValueList?: DataTableProps<TData>['filterValueList']
  onFilterChange?: DataTableProps<TData>['onFilterChange']
  bulkActionList?: DataTableProps<TData>['bulkActionList']
  toolbarActions?: DataTableProps<TData>['toolbarActions']
  isLoading: boolean
  emptyMessage: string
  className?: string
}

/**
 * Normalizes DataTable props with default values.
 */
export const useDataTableProps = <TData>(
  props: DataTableProps<TData>
): NormalizedDataTableProps<TData> => ({
  data: props.data,
  columnList: props.columnList,
  getRowId: props.getRowId,
  isSelectable: props.isSelectable ?? false,
  selectedIdList: props.selectedIdList ?? [],
  onSelectionChange: props.onSelectionChange,
  actionList: props.actionList ?? [],
  pagination: props.pagination,
  onPageChange: props.onPageChange,
  onPageSizeChange: props.onPageSizeChange,
  searchValue: props.searchValue,
  onSearchChange: props.onSearchChange,
  searchPlaceholder: props.searchPlaceholder,
  sortBy: props.sortBy,
  sortOrder: props.sortOrder,
  onSortChange: props.onSortChange,
  filterList: props.filterList,
  filterValueList: props.filterValueList,
  onFilterChange: props.onFilterChange,
  bulkActionList: props.bulkActionList,
  toolbarActions: props.toolbarActions,
  isLoading: props.isLoading ?? false,
  emptyMessage: props.emptyMessage ?? 'No results found.',
  className: props.className,
})
